module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colla', {
    class: {
      'colla-element-of': _vm.hovered == true, 'collapp-comment-mode': _vm.commentMode == true
    },
    attrs: {
      "id": "collapp"
    },
    on: {
      "mouseover": function($event) {
        _vm.hovered = true
      },
      "mouseleave": function($event) {
        _vm.hovered = false
      },
      "click": _vm.addThread
    }
  }, [_c('colla', {
    directives: [{
      name: "draggable",
      rawName: "v-draggable",
      value: (_vm.draggableValue),
      expression: "draggableValue"
    }],
    staticClass: "collapp-control-panel"
  }, [_c('colla', {
    ref: _vm.handleId,
    staticClass: "collapp-handle"
  }, [_c('img', {
    staticClass: "collapp-dragable-handle",
    attrs: {
      "src": _vm.rootUrl + '/dist/logo.png',
      "alt": "move"
    }
  })]), _vm._v(" "), _c('colla', {
    staticClass: "collapp-pin collapp-dot collapp-blue collapp-large",
    attrs: {
      "title": "click to start comment mode"
    },
    on: {
      "click": _vm.commentModeToogle
    }
  }, [_vm._v("+")])], 1), _vm._v(" "), _c('colla', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.commentMode),
      expression: "commentMode"
    }],
    staticClass: "collapp-threads"
  }, _vm._l((_vm.threads), function(thread, index) {
    return _c('colla', {
      staticClass: "collapp-thread",
      style: (_vm.setThreadStyle(thread)),
      attrs: {
        "data-thread-id": thread.id
      }
    }, [_c('colla', {
      directives: [{
        name: "draggable",
        rawName: "v-draggable"
      }],
      staticClass: "collapp-pin collapp-dot collapp-blue",
      attrs: {
        "data-thread-id": thread.id
      },
      on: {
        "click": function($event) {
          _vm.getThreadComments(thread.id)
        },
        "mouseup": _vm.onStDragging
      }
    }, [_vm._v("\n                " + _vm._s(index + 1) + "\n            ")]), _vm._v(" "), _c('colla', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showComments == thread.id),
        expression: "showComments == thread.id"
      }],
      staticClass: "collapp-content"
    }, [_c('button', {
      staticClass: "collapp-close",
      on: {
        "click": function($event) {
          _vm.deleteThread(index)
        }
      }
    }, [_vm._v("x")]), _vm._v(" "), _c('colla', {
      staticClass: "collapp-name"
    }, [_vm._v(_vm._s(thread.name))]), _vm._v(" "), _c('colla', {
      staticClass: "collapp-time"
    }, [_vm._v(_vm._s(_vm._f("time")(thread.time)))]), _vm._v(" "), _c('CommentList', {
      attrs: {
        "thread": thread.id
      }
    })], 1)], 1)
  })), _vm._v(" "), _c('colla', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.commentMode),
      expression: "commentMode"
    }],
    staticClass: "collapp-window-info"
  }, [_vm._v("\n        RecordSize " + _vm._s(_vm.projectScreen.width) + "x" + _vm._s(_vm.projectScreen.height)), _c('br'), _vm._v(" your window sizes " + _vm._s(_vm.screen.width) + "x" + _vm._s(_vm.screen.height) + "\n    ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-59c95520!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 25
// module chunks = 0